import { createAsyncThunk, createSlice, nanoid } from "@reduxjs/toolkit";
import { GetUserProfile } from "../../services/ProfileService";

const initialState = {
	profiles: { lastName: "حساب کاربری", firstName: "", id: "" } as any,
	status: "idle",
	loggedin: false,
	error: "" as string | undefined,
};

export const fetchUserProfile = createAsyncThunk(
	"/profile/fetchUserProfile",
	async () => {
		const response = await GetUserProfile();
		return response.data;
	}
);

export const updateNotices = createAsyncThunk(
	"/profile/UpdateProdile",
	async (data: any) => {
		//const response = await SetUserProfile(data.id);
		return; // { image: response.data, id: data.id };
	}
);

const profileSlice = createSlice({
	name: "profiles",
	initialState: initialState,
	reducers: {},

	extraReducers: (builder) => {
		builder
			.addCase(fetchUserProfile.pending, (state, action) => {
				state.status = "loading";
			})
			.addCase(fetchUserProfile.fulfilled, (state, action) => {
				if (action.payload.statusCode === 200) {
					state.profiles = action.payload.data;
					state.status = "idle";
				} else {
					state.profiles = { firstName: "", lastName: "حساب کاربری" };
					state.status = "idle";
				}
				state.loggedin = true;
			})
			.addCase(fetchUserProfile.rejected, (state, action) => {
				state.profiles = { firstName: "", lastName: "حساب کاربری" };
				state.error = action.error.message;
				state.status = "idle";
				state.loggedin = false;
			});
		//       .addCase(updateNotices.fulfilled, (state, action) => {
		//         console.log(action.payload);
		//         const { id, image } = action.payload;
		//         console.log(state.notices.findIndex((notice: any) => notice.id === id));
		//
		//         const updatedNoticeIndex = state.notices.findIndex(
		//           (notice: any) => notice.id === id
		//         );
		//         //console.log(state.notices[updatedNoticeIndex]);
		//
		//         state.notices[updatedNoticeIndex].image = image;
		//       });
	},
});

export const getMyProfile = (state: any) => state.profiles.profiles;
export const loggedInProfile = (state: any) => state.profiles.loggedin;

export default profileSlice.reducer;
